<template>
  <div v-cloak>
    <div class="header">
      <div v-if="scheduleDownload" v-html="scheduleDownload"></div>

      <div class="tab _pc">
        <ul>
          <li><router-link to="day25" :class="{'tab_active': page == 0}">10.25<small>[THU]</small></router-link></li>
          <li><router-link to="day26" :class="{'tab_active': page == 1}">10.26<small>[FRI]</small></router-link></li>
          <li><router-link to="day27" :class="{'tab_active': page == 2}">10.27<small>[SAT]</small></router-link></li>
          <li><router-link to="day28" :class="{'tab_active': page == 3}">10.28<small>[SUN]</small></router-link></li>
          <li><router-link to="day29" :class="{'tab_active': page == 4}">10.29<small>[MON]</small></router-link></li>
          <li><router-link to="day30" :class="{'tab_active': page == 5}">10.30<small>[TUE]</small></router-link></li>
          <li><router-link to="day31" :class="{'tab_active': page == 6}">10.31<small>[WED]</small></router-link></li>
          <li><router-link to="day01" :class="{'tab_active': page == 7}">11.1<small>[THU]</small></router-link></li>
          <li><router-link to="day02" :class="{'tab_active': page == 8}">11.2<small>[FRI]</small></router-link></li>
          <li><router-link to="day03" :class="{'tab_active': page == 9}">11.3<small>[SAT]</small></router-link></li>
        </ul>
      </div>

      <div class="nav _sp">
        <form name="fm">
          <select name="s" @change="changeRoute" v-model="page">
            <option value="" disabled>Screening date</option>
            <option value="0">10.25 [THU]</option>
            <option value="1">10.26 [FRI]</option>
            <option value="2">10.27 [SAT]</option>
            <option value="3">10.28 [SUN]</option>
            <option value="4">10.29 [MON]</option>
            <option value="5">10.30 [TUE]</option>
            <option value="6">10.31 [WED]</option>
            <option value="7">11.1 [THU]</option>
            <option value="8">11.2 [FRI]</option>
            <option value="9">11.3 [SAT]</option>
          </select>
        </form>
        <div class="date" :var:cont="currentday | datedotformat" v-if="currentday">
          <span :var:cont="currentday | datedotformat" var:omit-tag="true">{{currentday | datedotformat}}</span>
          <small>[<span :var:cont="currentday | dayformat" var:omit-tag="true">{{currentday | dayformat}}</span>]</small>
        </div>
      </div>
    </div>
    <div class="relative">
      <div class="infinite-loading-container" :class="{'hidden': loaded}">
        <div>
          <i class="loading-default"></i>
        </div>
      </div>
      <div class="timetable" v-show="loaded">
        <div v-show="area[currentday]" v-for="(area, aindex) in acts">
          <div class="area">{{area.name_en}}</div>
          <div v-show="cinema[currentday]" v-for="(cinema, cindex) in area.children">
            <div class="theater">{{cinema.name_en}}</div>
            <div class="schedule" :class="{'-toho': cindex == 0 && aindex == 0}">
              <div v-if="act.column > 0 && currentday == act.act_date" v-for="act in cinema.acts" class="box" :class="['column' + act.column, 'screen' + act.venue.order]">
                <div class="time">
                  <span class="start" v-if="act.open_at">{{act.open_at | timeformat}}</span> - (<span class="length">{{act.film.film_time_length}}</span>)
                  <span v-if="act.ticket_status == 3" class="seat -status-1">◎</span>
                  <span v-if="act.ticket_status == 2" class="seat -status-2">△</span>
                  <span v-if="act.ticket_status == 1" class="seat -status-3">✕</span>
                  <span v-if="act.ticket_status == 0" class="seat">-</span>
                  <span v-if="act.is_show_flag_free" class="seat -status-4">Free</span>
                </div>
                <div class="title"><a :href="'../../lineup/film/' + act.film.film_identifier">{{act.show_title_en}}</a></div>
                <div class="icons">
                  <div v-if="act.is_event_sa" class="icon -qa">Stage Greeting</div>
                  <div v-if="act.is_event_qa" class="icon -talkshow">Q&amp;A</div>
                  <div v-if="act.is_event_ts" class="icon -greeting">Talk show</div>
                  <div v-if="act.is_event_award" class="icon -award-ceremony">Award Celemony</div>
                  <div v-if="act.is_event_event" class="icon -event">Event</div>
                </div>
                <div class="info">
                  <span v-if="act.is_show_flag_advanced" class="preceding-lottery">Pre-order lottery</span>
                  <span v-if="act.is_show_flag_application" class="pre-registration">Advance application</span>
                  <span v-if="act.is_show_flag_end" class="cut-off">Closed</span>
                </div>
              </div><!-- /.box -->
            </div>
          </div>
          <div v-if="aindex == 0" id="nav" class="tab _pc">
            <ul>
              <li><router-link to="day25#nav" :class="{'tab_active': page == 0}">10.25<small>[THU]</small></router-link></li>
              <li><router-link to="day26#nav" :class="{'tab_active': page == 1}">10.26<small>[FRI]</small></router-link></li>
              <li><router-link to="day27#nav" :class="{'tab_active': page == 2}">10.27<small>[SAT]</small></router-link></li>
              <li><router-link to="day28#nav" :class="{'tab_active': page == 3}">10.28<small>[SUN]</small></router-link></li>
              <li><router-link to="day29#nav" :class="{'tab_active': page == 4}">10.29<small>[MON]</small></router-link></li>
              <li><router-link to="day30#nav" :class="{'tab_active': page == 5}">10.30<small>[TUE]</small></router-link></li>
              <li><router-link to="day31#nav" :class="{'tab_active': page == 6}">10.31<small>[WED]</small></router-link></li>
              <li><router-link to="day01#nav" :class="{'tab_active': page == 7}">11.1<small>[THU]</small></router-link></li>
              <li><router-link to="day02#nav" :class="{'tab_active': page == 8}">11.2<small>[FRI]</small></router-link></li>
              <li><router-link to="day03#nav" :class="{'tab_active': page == 9}">11.3<small>[SAT]</small></router-link></li>
            </ul>
          </div>
        </div>

        <div v-if="scheduleEvent" v-html="scheduleEvent"></div>
        <div v-if="scheduleIcon" v-html="scheduleIcon"></div>
      </div>
    </div>

    <div class="floating-nav" v-show="loaded">
      <div v-if="page != 0" class="prev"><a @click="prevParam"><img src="/img/schedule/btn_prev_schedule.png" alt="prev" /></a></div>
      <div v-if="page != 9" class="next"><a @click="nextParam"><img src="/img/schedule/btn_next_schedule.png" alt="Next" /></a></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .v-cloak ,
  [v-cloak] {
    visibility:hidden;
  }
  .pre-br {
    white-space: pre-wrap;
  }
  .p-schedule .tab .tab_active {
    border-bottom: 4px solid #8f0000;
  }
  .p-schedule .timetable .box.screen1 {
    top: 0;
  }
  .p-schedule .timetable .box.screen2 {
    top: 107px;
  }
  .p-schedule .timetable .box.screen3 {
    top: 214px;
  }
  .p-schedule .timetable .box.screen4 {
    top: 321px;
  }
  .p-schedule .timetable .box.screen5 {
    top: 428px;
  }
  .p-schedule .timetable .box.screen6 {
    top: 535px;
  }
  .p-schedule .timetable .box.screen7 {
    top: 642px;
  }
  .p-schedule .timetable .box.screen8 {
    top: 749px;
  }
  .p-schedule .timetable .box.screen9 {
    top: 856px;
  }
  .p-schedule .timetable .box.column1 {
    left: 35px;
  }
  .p-schedule .timetable .box.column2 {
    left: 216px;
  }
  .p-schedule .timetable .box.column3 {
    left: 397px;
  }
  .p-schedule .timetable .box.column4 {
    left: 578px;
  }
  .p-schedule .timetable .box.column5 {
    left: 759px;
  }
	a {
		cursor: pointer;
	}
  @media screen and (max-width: 639px) {
    .p-schedule .timetable .-toho {
      .box.screen1 {
        background-image: url('/img/schedule/ico_screen1.png');
      }
      .box.screen2 {
        background-image: url('/img/schedule/ico_screen2.png');
      }
      .box.screen3 {
        background-image: url('/img/schedule/ico_screen3.png');
      }
      .box.screen4 {
        background-image: url('/img/schedule/ico_screen4.png');
      }
      .box.screen5 {
        background-image: url('/img/schedule/ico_screen5.png');
      }
      .box.screen6 {
        background-image: url('/img/schedule/ico_screen6.png');
      }
      .box.screen7 {
        background-image: url('/img/schedule/ico_screen7.png');
      }
      .box.screen8 {
        background-image: url('/img/schedule/ico_screen8.png');
      }
      .box.screen9 {
        background-image: url('/img/schedule/ico_screen9.png');
      }
      .box .time {
        padding-left: 95px;
      }
    }
  }
  .relative {
    position: relative;
    min-height: 200px;
  }
  .infinite-loading-container{
    clear: both;
    height: 200px;
    text-align: center;
    position: absolute;
    top: 0;
    transition: 0s;
    transition-delay: .4s;
    width: 100%;
    z-index: 1;
    &.hidden {
      height: 0;
      overflow: hidden;
      .loading-default {
        opacity: 0;
      }
    }
    .loading-default {
      animation: loading-rotating ease 1.5s infinite;
      border: 1px solid #999;
      border-radius: 50%;
      display: inline-block;
      font-size: 28px;
      line-height: 28px;
      height: 28px;
      position: relative;
      margin: 120px 0;
      opacity: 1;
      transition: .4s;
      width: 28px;
      &:before {
        content: "";
        position: absolute;
        display: block;
        top: 0;
        left: 50%;
        margin-top: -3px;
        margin-left: -3px;
        width: 6px;
        height: 6px;
        background-color: #999;
        border-radius: 50%;
      }
    }
  }
  @keyframes loading-rotating {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(1turn);
    }
  }
</style>

<script>

import axios from 'axios'
import {apiEnv} from '../env.js'
var apiPath = apiEnv();
import schedule from '../mixins/schedule'

export default {
  name: 'Schedule',
  mixins: [schedule],
  beforeCreate () {
    axios
      .get('/en/include/schedule_download.inc')
      .then((res) => {
        this.scheduleDownload = res.data
      })
    axios
      .get('/en/include/schedule_event.inc')
      .then((res) => {
        this.scheduleEvent = res.data
      })
    axios
      .get('/en/include/schedule_icon.inc')
      .then((res) => {
        this.scheduleIcon = res.data
      })
  },
  created () {
    this.today = this.scheduleLinkFormat()
    if(this.$route.params.id && (
       this.$route.params.id == 'day25' ||
       this.$route.params.id == 'day26' ||
       this.$route.params.id == 'day27' ||
       this.$route.params.id == 'day28' ||
       this.$route.params.id == 'day29' ||
       this.$route.params.id == 'day30' ||
       this.$route.params.id == 'day31' ||
       this.$route.params.id == 'day01' ||
       this.$route.params.id == 'day02' ||
       this.$route.params.id == 'day03' )
    ) {
      this.changeParam(this.$route.params.id)
    } else {
      this.$router.push({path: '/en/schedule/list/' + this.today})
    }
	},
  methods: {
    changeRoute () {
      this.$router.push({path: '/en/schedule/list/' + Object.keys(this.daymap)[this.page]})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/ScheduleEn.vue